const cookie = {
  /**
   * 设置cookie方法
   * @param   {string}  key  cookie键值
   * @param   {string}  value  cookie对应的键值内容
   */
  setCookie(key, value) {
    var exdate = new Date(),
      expiredays = 365;
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      key +
      "=" +
      escape(value) +
      ";expires=" +
      exdate.toGMTString() +
      ";path=/;domain=.xueersi.com";
  },
  /**
   * 获取cookie方法
   * @param   {string}  name  cookie键值
   * @return  {*}  返回cookie值
   */
  getCookie(name) {
    if (document.cookie.length > 0) {
      var start = document.cookie.indexOf(name + "=");
      if (start !== -1) {
        start = start + name.length + 1;
        var end = document.cookie.indexOf(";", start);
        if (end === -1) {
          end = document.cookie.length;
        }
        return unescape(document.cookie.substring(start, end));
      }
    }
    return "";
  },
};

export default cookie;
